export default __webpack_public_path__ + "static/card-restyling-0d5beb6842f40b5329c101067687deaf.png";